export enum ChangeEmailTexts {
    TITLE = 'E-Mail-Adresse ändern',
    DESCRIPTION = 'Geben Sie hier Ihre neue E-Mail-Adresse ein.',
    CHANGE = 'Ändern',
    BUTTON_FIRST_PLACEHOLDER = 'Neue E-Mail-Adresse',
BUTTON_SECOND_PLACEHOLDER = 'Neue E-Mail-Adresse (wiederholen)'
}
